import React from 'react';

import { useLocation } from 'react-router-dom';

import Box from '@amzn/meridian/box';
import Text from '@amzn/meridian/text';
import { AdminConfigPaths } from 'src/store/adminConfigPageSlice/common/constants';

import './restrictionFormConfiguration.scss';

import FormTaskConfiguration from './formTaskConfiguration/formTaskConfiguration';
import RestrictionFormsTableContainer from './restrctionFormsTableContainer/restrictionFormsTableContainer';
import RestrictionFormConfigurationTabGroup from './restrictionFormConfigurationTabGroup/restrictionFormConfigurationTabGroup';

// **** Components **** //

/**
 * Default component.
 */
const RestrictionFormConfiguration = () => {
  return (
    <div className="view-and-edit-forms">
      <Text className="view-and-edit-forms__content__text">
        Here you can update the regional work Restriction/Requirement forms available within the RTW tool
      </Text>
      <div>
        <RestrictionFormConfigurationTabs />
      </div>
    </div>
  );
};

/**
 * Toggle between the
 */
const RestrictionFormConfigurationTabs = () => {
  const location = useLocation();
  const { TABLE, EDIT, root } = AdminConfigPaths.Form;
  return (
    <div className="view-and-edit-forms">
      <Box spacingInset="100 none none none">
        <RestrictionFormConfigurationTabGroup />
      </Box>
      <Box type="outline" spacingInset="200 500 400 500">
        {location.pathname === TABLE || location.pathname === root ? (
          <RestrictionFormsTableContainer />
        ) : location.pathname.startsWith(EDIT) ? (
          <FormTaskConfiguration />
        ) : null}
      </Box>
    </div>
  );
};

// **** Export **** //

export default RestrictionFormConfiguration;
